module.exports = __webpack_public_path__ + "static/media/reservations.6a5470b0.webp";